<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="800"
  )
    v-card(:loading="loading")
      v-card-title
        | Copy Ad

      v-card-text
        v-layout(row)
          v-flex
            v-data-table(
              :headers="headers"
              :items="items"
              item-key="adGroup.id"
              v-model="itemSelecteds"
              show-select
            )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" :disabled="!isReady" @click="doSubmit") Start Copy
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import { mapActions } from 'vuex'
import { copyAds } from '@/helpers'

export default {
  props: {
    customerId: [String, Number],
    adSelecteds: [Array]
  },
  data () {
    return {
      active: false,
      loading: false,
      items: [],
      itemSelecteds: [],
      headers: [
        { text: 'Name', value: 'adGroup.name' },
        { text: 'Campaign', value: 'campaign.name' }
      ]
    }
  },
  mounted () {
  },
  computed: {
    isReady () {
      return (this.itemSelecteds.length !== 0) && ((this.adSelecteds || []).length !== 0)
    }
  },
  methods: {
    ...mapActions({
      'loadAdGroups': 'ads/loadAdGroups'
    }),
    show () {
      this.active = true
      this.loading = false
      this.doLoadAdGroups()
    },
    hide () {
      this.active = false
    },
    async doLoadAdGroups () {
      this.loading = true
      this.items = await this.loadAdGroups({ customerId: this.customerId })
      this.loading = false
    },
    async doCopyAds () {
      return copyAds(this.customerId, this.adSelecteds, this.itemSelecteds)
    },
    async doSubmit () {
      this.loading = true
      await this.doCopyAds()
      this.hide()
    }
  }
}
</script>

<style lang="stylus" scoped></style>
